import React, { useState } from "react";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useTableSearch } from "core/Operations/useTableSearch";
import Error404 from "MainPages/ErrorPages/error404";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Edit, PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import TableTop from "Components/UI/TableTop";
import Select from "react-select";
import { useGetEmpAdditionsQuery } from "AppQuries/payroll/addition/emp-addition";
import Datatable from "core/pagination/datatable";
import { useGetAllDepartmentQuery } from "AppQuries/master/Department/get-all-departments";
import { useGetAdditionsQuery } from "AppQuries/payroll/addition/get-all-additions";
import { format } from "date-fns";
const EmployeeAllowance = () => {
  const userData = useSelector(loggedInUser);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedPayslip, setSelectedPayslip] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [employeeCode, setEmployeeCode] = useState(0);
  const [departmentCode, setDepartmentCode] = useState(0);
  const [allowanceCode, setAllowanceCode] = useState(0);
  const {
    data,
    isFetching,
    isError,
    error,
    refetch: getEmpAllowance,
  } = useGetEmpAdditionsQuery(
    {
      companyCode: userData.companyCode,
      locationCode: userData.locationCode,
      typeCode: allowanceCode,
      departmentCode: departmentCode,
    },
    {
      enabled: !!employeeCode && !!departmentCode && !!userData?.companyCode,
    }
  );


  const allowanceData = Array.isArray(data)
    ? data?.map((d, _id) => ({
        ...d,
        id: _id,
      }))
    : [];

  //   const { data: employees } = useGetEmployeeQuery();
  const { data: departments } = useGetAllDepartmentQuery({
    companyCode: userData?.companyCode,
    isTrue: true,
  });
  const { data: allowance } = useGetAdditionsQuery({
    companyCode: userData?.companyCode,
  });

  //   const employeeOptions = Array.isArray(employees?.data)
  //     ? employees?.data
  //         .filter((d) => d.isActive)
  //         .map((o) => ({
  //           id: o.employeeCode,
  //           label: `${o.uniqueId}-${o.fullName}`,
  //           value: o.employeeCode,
  //         }))
  //     : [];

  const departmentOptions = Array.isArray(departments?.data)
    ? departments?.data
        .filter((d) => d.isActive)
        .map((o) => ({
          id: o.code,
          label: o.description,
          value: o.code,
        }))
    : [];
  const allowanceOptions = Array.isArray(allowance?.data)
    ? allowance?.data
        // .filter((d) => d.isActive)
        .map((o) => ({
          id: o.code,
          label: o.description,
          value: o.code,
        }))
    : [];
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      sorter: (a, b) => a.employeeName.length - b.employeeName.length,
    },
    {
      title: "Allowance Name",
      dataIndex: "description",
      sorter: (a, b) => a.description.length - b.description.length,
    },

    {
      title: "have CPF",
      dataIndex: "haveCPF",
      sorter: (a, b) => a.haveCPF.length - b.haveCPF.length,
      render: (text, record) => (
        <>
          {text === true && <div className="bg-lightgreen">Yes</div>}
          {text === false && <div className="bg-lightred">No</div>}
        </>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => a.amount.length - b.amount.length,
    },
    {
      title: "Start Date",
      dataIndex: "effectiveDateFrom",
      sorter: (a, b) => a.effectiveDateFrom.length - b.effectiveDateFrom.length,
      render: (text, record) => format(new Date(text), "dd-MM-yyyy"),
    },

    {
      title: "End Date",
      dataIndex: "effectiveDateTo",
      sorter: (a, b) => a.effectiveDateTo.length - b.effectiveDateTo.length,
      render: (text, record) => format(new Date(text), "dd-MM-yyyy"),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Link
            className="me-2 p-2"
            to={`${all_routes.edit_emp_allowance}/${record.allowanceCode}`}
          >
            <Edit className="feather-edit" />
          </Link>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column, index) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    allowanceData,
    searchColumns
  );
  //   if (isFetching) return <LoadingSpinner />;
  //   if (isError) return <Error404 error={error} />;
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Allowance Management</h4>
                <h6>Manage Employee Allownace Details</h6>
              </div>
            </div>

            <div className="page-btn">
              <Link
                to={`${all_routes.add_emp_allowance}`}
                className="btn btn-added"
              >
                <PlusCircle className="me-2" />
                Add New Allowance
              </Link>
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                showToggle={true}
              />
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                // style={{ display: isFilterVisible ? "block" : "none" }}
              >
                
                <div className="card-body pb-0">
                  <div className="form-row row">
                    <div className="row">
                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <label className="form-label">Allowance </label>

                          <Select
                            className="select"
                            options={allowanceOptions}
                            placeholder="Allowance"
                            value={allowanceOptions.find(
                              (option) => option.value === employeeCode
                            )}
                            onChange={(e) => {
                              setAllowanceCode(e?.value || 0);
                            }}
                            isClearable
                            //   styles={{
                            //     control: (baseStyles, state) => ({
                            //       ...baseStyles,
                            //       fontSize: "12px",
                            //       width: "100px",
                            //     }),
                            //   }}
                          />
                        </div>
                      </div>

                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <label className="form-label">Department </label>

                          <Select
                            className="select"
                            options={departmentOptions}
                            placeholder="Department"
                            value={departmentOptions.find(
                              (option) => option.value === employeeCode
                            )}
                            onChange={(e) => {
                              setDepartmentCode(e?.value || 0);
                            }}
                            isClearable
                            //   styles={{
                            //     control: (baseStyles, state) => ({
                            //       ...baseStyles,
                            //       fontSize: "12px",
                            //       width: "100px",
                            //     }),
                            //   }}
                          />
                        </div>
                      </div>

                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="input-blocks">
                          <label className="form-label">&nbsp;</label>
                          <Link
                            className="btn btn-filters ms-auto"
                            onClick={getEmpAllowance}
                            type="button"
                          >
                            <i
                              data-feather="search"
                              className="feather-search"
                            />
                            {/* {isFetching ? (
                              <>
                                <i className="fas fa-spinner fa-spin me-2"></i>
                                Loading...
                              </>
                            ) : ( */}
                            <>Filter</>
                            {/* )} */}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <Datatable
                  columns={columns}
                  dataSource={filteredData}
                  rowKey={(record) => record.key}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeAllowance;
